import { render, staticRenderFns } from "./MyReservations.vue?vue&type=template&id=0aa8c7b6&scoped=true"
import script from "./MyReservations.vue?vue&type=script&lang=js"
export * from "./MyReservations.vue?vue&type=script&lang=js"
import style0 from "./MyReservations.vue?vue&type=style&index=0&id=0aa8c7b6&prod&scoped=true&lang=css"
import style1 from "./MyReservations.vue?vue&type=style&index=1&id=0aa8c7b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa8c7b6",
  null
  
)

export default component.exports